export default "__VITE_ASSET__DRpx_lGl__"